import { render, staticRenderFns } from "./AppImage.vue?vue&type=template&id=15c2f309&scoped=true"
import script from "./AppImage.vue?vue&type=script&lang=js"
export * from "./AppImage.vue?vue&type=script&lang=js"
import style0 from "./AppImage.vue?vue&type=style&index=0&id=15c2f309&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c2f309",
  null
  
)

export default component.exports